import React from "react";

const Subscribe = () => {
  return (
    <div className="container">
      <div className="col py-3">
        <div className="col text-center">
          <p className="fs-3">Subscribe Form</p>
        </div>
        <div className="col d-grid col-6 mx-auto">
          <form>
            <input
              type="email"
              className="form-control"
              placeholder="Email Address"
              aria-label="Username"
              aria-describedby="basic-addon1"
              required
            />

            <div className="d-grid my-3 mx-auto">
              <button
                className="btn btn-dark py-2"
                type="button"
                placeholder="Password"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
        {/* <div className="col text-center">
          <div className="mt-5"><i class="fa-brands fa-2x fa-linkedin"></i></div>
        </div> */}
      </div>
    </div>
  );
};

export default Subscribe;
